module.exports = __webpack_public_path__ + "media/images/about-us/PGA/Philadelphia PGA-74b26287532dccb5b476db124838fd99.png";